/* eslint-disable */
export enum MessageType {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info'
}

